import React from 'react';
import { useSelector } from 'react-redux';
import ZenSignHeader from './ZenSignHeader';
import ShareHeader from './ShareHeader';

function Header() {
  const type = useSelector((state) => state.auth.user.type);

  if (type === 'folder-share') {
    return <ShareHeader />;
  }

  return <ZenSignHeader />;
}

export default Header;
